// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"22fb24e3","267":"9acbcd98","626":"388ae170","710":"cf24109d","723":"388ae170","870":"883a134c"}[chunkId] + ".chunk.css";
};